export const EDIT_WIDGETS = 'EDIT_WIDGETS'
export const ADD_WIDGET = 'ADD_WIDGET'
export const REMOVE_WIDGET = 'REMOVE_WIDGET'
export const INIT_WORKSPACE_WIDGETS = 'INIT_WORKSPACE_WIDGETS'
